import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private http: HttpClient) {
  }

  reset(email: string, password: string, passwordConfirmation: string, token: string): Observable<object> {
    return this.http.post(`${environment.api}/api/password/reset`, {
      email,
      token,
      password,
      password_confirmation: passwordConfirmation
    });
  }
}
